import React from 'react';

export const CalculatedOutput = ({value, units, label, color, error, removeUnderlines = false, mainWrapperClassName=''}) => {
  if (removeUnderlines && typeof value === 'string') value = value.replace(/_/g, ' ');

  return (
    <div className={`ect-output ${mainWrapperClassName}`}>
      <label>{label}</label>
      <div className={`output ${error ? 'red' : color || 'green'}`}>
        {`${(value !== undefined && value !== null) ? fixedValue(value) : ''} ${units || ''}`}
      </div>
      {typeof error === 'string' && <div className='error-message'>{error}</div>}
    </div>
  );
};

export const CalculatedMultiOutput = ({value, units, label, color, error}) => (
  <div className='ect-multi-output'>
    <label>{label}</label>
    <div
      className={`output ${error ? 'red' : color || 'green'}`}>{`${(value !== undefined && value !== null) ? fixedValue(value) : ''} ${units || ''}`}</div>
    {typeof error === 'string' && <div className='error-message'>{error}</div>}
  </div>
);

function fixedValue(value) {
  if (value === null) return 0;
  const dotIndex = value.toString().indexOf('.');
  if (dotIndex !== -1 && dotIndex + 3 < value.toString().length) return (+value).toFixed(2);
  return value;
}



// WEBPACK FOOTER //
// ./src/app/Components/CalculatedOutput.jsx